import "./partnerReviewList.scss";
// utils
// import { SAMSUNG_EVENT_WEGAZINE_UUID } from '@src/utils'; // 현재 이벤트 종료로 사용없음
// api
import { IPartner, IPartnerMinimum } from "../../api/partner/partner";
import { getCommunityList, getBlogList } from "@src/api/community/community";
// partner
import { PartnerTabId } from "@src/define/partner";
// review
import { ReviewProviderComponent } from "./review/Provider";
import ReviewListSection from "./review/ListSection";
import ReviewDetailSection from "./review/DetailSection";
import BlindReviewListSection from "./review/BlindSection";

// 최종 리뷰 리스트
export const PartnerReviewList = ({
  partner,
  activeParentTabId,
}: {
  partner: IPartner | IPartnerMinimum;
  activeParentTabId: number;
}) => {
  return (
    <>
      <ReviewProviderComponent
        partnerDataProvider={partner}
        apiFunctionProvider={{
          // 이런 식으로 api 호출할 함수 넣어주세요
          getCommunityList: getCommunityList, //일반리뷰
          getBlogList: getBlogList, //블로그리뷰
          getBlindList: getCommunityList, //블라인드리뷰
        }}
        partnerTypeProvider="default" //weddinghall 이라면 weddinghall
        parentTabNumberProvider={PartnerTabId.Review}
      >
        <ReviewListSection activeParentTabId={activeParentTabId} />
      </ReviewProviderComponent>
    </>
  );
};

// 최종 블라인드 후기 리스트
export const PartnerBlindReviewList = ({ partnerUuid }: { partnerUuid: string }) => {
  return (
    <>
      <ReviewProviderComponent
        partnerDataProvider={null}
        apiFunctionProvider={{
          // 이런 식으로 api 호출할 함수 넣어주세요
          getCommunityList: null, //일반리뷰
          getBlogList: null, //블로그리뷰
          getBlindList: getCommunityList, //블라인드리뷰
        }}
        partnerTypeProvider="default" //weddinghall 이라면 weddinghall
        parentTabNumberProvider={null}
      >
        <BlindReviewListSection partnerUuid={partnerUuid} />
      </ReviewProviderComponent>
    </>
  );
};

// 최종 리뷰 상세
export const PartnerReviewDetailPage = () => {
  return (
    <>
      <ReviewProviderComponent
        partnerDataProvider={null}
        apiFunctionProvider={{
          // 이런 식으로 api 호출할 함수 넣어주세요
          getCommunityList: null, //일반리뷰
          getBlogList: null, //블로그리뷰
          getBlindList: null, //블라인드리뷰
        }}
        partnerTypeProvider="default" //weddinghall 이라면 weddinghall
        parentTabNumberProvider={null}
      >
        <ReviewDetailSection />
      </ReviewProviderComponent>
    </>
  );
};
